import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GetAllSpecialsDto } from "../models/specials/getAllSpecials";
import { GenericRequestDto } from "../models/common/genericRequestDto";

@Injectable({
  providedIn: "root",
})
export class ExternalService {
  private externalBaseURL = environment.baseUrl + "/External";

  constructor(private _http: HttpClient) {}

  getAllSpecials(
    payload: GenericRequestDto
  ): Observable<GenericResponseDto<GetAllSpecialsDto[]>> {
    return this._http.post<GenericResponseDto<GetAllSpecialsDto[]>>(
      this.externalBaseURL + `/GetAllSpecials`,
      payload
    );
  }

  getSpecialsByVendorAccount(
    vendorAccountNumber: string
  ): Observable<GenericResponseDto<GetAllSpecialsDto[]>> {
    return this._http.get<GenericResponseDto<GetAllSpecialsDto[]>>(
      this.externalBaseURL + `/GetSpecialsByVendorAccount/${vendorAccountNumber}`
    );
  }
}
